export type CrmEntityKey = "company" | "contact" | "lead" | "pipeline" | "deal" | "proposal" | "contract";

export const ENTITY_ICONS: Record<CrmEntityKey, string> = {
  company: "ti ti-building-community",
  contact: "ti ti-user-up",
  lead: "ti ti-chart-arcs",
  pipeline: "ti ti-timeline-event-exclamation",
  deal: "ti ti-medal",
  proposal: "ti ti-file-text",
  contract: "ti ti-file-certificate",
};
